"use client"
import ContentWithForm from "reusable/ContentWithForm"
import { getColorCodes } from "../../api/delek"
import { ButtonType, ContentItemType } from "../../typings/contentPage"

const ColorCodePage = () => {
  const buttons: ButtonType[] = [
    { value: "licenseNumber", name: "מס׳ לוחית רישוי" },
    { value: "chassis", name: "מס׳ שלדה" },
  ]

  const headerText = [
    `לכל צבע יש קוד משלו. כדי להבטיח שצבע מסוים יהיה זהה בדיוק לצבע המקורי, יש להקליד כאן את מספר לוחית הרישוי או השלדה – ונציג את קוד הצבע של המאזדה שלך`,
  ]

  return (
    <ContentWithForm
      title="בדיקת קוד צבע"
      headerText={headerText}
      background={["/img/colorcodemobile.jpg", "/img/colorcode.jpg"]}
      buttons={buttons}
      inputLabel="מס׳ לוחית רישוי (משמאל לימין)"
      inputType="text"
      submitText="לבדיקה"
      bottomTitle="שירות הלקוחות שלנו זמין בשבילך לכל עניין:"
      phoneNumber="*2880"
      getData={getColorCodes}
      type={ContentItemType.COLOR}
      page={"color"}
      breadCrumbName={"ColorCode"}
    />
  )
}

export default ColorCodePage
